import { Grid, useMediaQuery } from "@mui/material";
import { Visibility } from "@mui/icons-material";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { ListAction, ListActions, StyledListItem, StyledListWrapper, StyledPagination } from "@framework/styled";
import { IRaffleToken, TokenStatus } from "@framework/types";
import { useDialogView, useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { List } from "@dzambalaorg/ui-kit";

import { RaffleTokenDialogView } from "./view";
import { RaffleTokenSearchForm } from "./search";

const RAFFLE_TICKETS_TOKENS_URL = "/raffle/ticket/tokens";
const RAFFLE_TICKETS_TOKENS_VIEW_DIALOG_KEY = "raffleTicketTokens";

export const RaffleTicketTokens = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IRaffleToken>
  >(RAFFLE_TICKETS_TOKENS_URL, { enableInfiniteScroll: isMd }, void 0, {
    tokenStatus: [TokenStatus.MINTED],
  });

  const { viewItem, handleView, viewDialogUniqueKey, closeViewDialog, viewMode } = useDialogView<IRaffleToken>();

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "raffle", "raffle.tokens"]} />

      <PageHeader message="pages.raffle.tokens.title" />

      <RaffleTokenSearchForm />

      <ProgressOverlay isLoading={isLoading}>
        <StyledListWrapper count={allRows.length} isLoading={isLoading}>
          {allRows.map(token => (
            <StyledListItem key={token.id}>
              <List.ItemText sx={{ width: 0.2 }}>#{token.tokenId}</List.ItemText>
              <List.ItemText sx={{ width: 0.2 }}>
                {"Round #"}
                {token.round.roundId}
                {" ("}
                {token.round.id}
                {")"}
              </List.ItemText>
              <List.ItemText sx={{ width: 0.2 }}>
                {token.metadata.PRIZE ? "Prize " : ""}
                {token.round.number === token.tokenId ? "winner" : ""}
              </List.ItemText>

              <ListActions>
                <ListAction
                  message="form.tips.view"
                  icon={Visibility}
                  onClick={handleView(RAFFLE_TICKETS_TOKENS_VIEW_DIALOG_KEY, token, "view")}
                />
              </ListActions>
            </StyledListItem>
          ))}
        </StyledListWrapper>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}

      <RaffleTokenDialogView
        onCancel={closeViewDialog}
        onConfirm={closeViewDialog}
        open={viewDialogUniqueKey === `${RAFFLE_TICKETS_TOKENS_VIEW_DIALOG_KEY}.${viewMode}`}
        viewItem={viewItem}
      />
    </Grid>
  );
};
